module.exports = __webpack_public_path__ + "static/media/video_1_imagem.d24fcfd5.png";